var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "62px",
    viewBox: "0 0 61 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Watchclock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portal---pending",
    transform: "translate(-586.000000, -248.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Watchclock",
    transform: "translate(587.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-96",
    strokeLinecap: "round",
    cx: 29.4545455,
    cy: 29.4545455,
    r: 29.4545455
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-96-Copy",
    strokeLinecap: "round",
    cx: 29.4545455,
    cy: 29.4545455,
    r: 3.27272727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4545455,26.1818182 L29.4545455,9.78185847",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7272727,32.7272727 L43.6363636,43.6363636",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81818182,8.72727273 L11.5430606,10.4521515 M49.6363636,9.27272727 L47.9114849,10.997606 M49.0909091,49.0909091 L47.3660303,47.3660303 M9.27272727,48.5454545 L10.997606,46.8205758",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4545455,0 L29.4545455,4.4979333",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4545455,54.5454545 L29.4545455,59.0433878",
    id: "Line-Copy-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9090909,29.4545455 L53.4545455,29.4545455",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45454545,29.4545455 L0,29.4545455",
    id: "Line-Copy-3",
    strokeLinecap: "square"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.a534ba79a528192ba2174c48d0c09277.svg";
export { ForwardRef as ReactComponent };